import BaseService from './BaseService';

export default class UserService extends BaseService {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'user';
    }

    sendLinkForGenerateNewPassword(email, firstLogin) {
        const encodedEmail = encodeURIComponent(email);
        return this.fetch(`${this.domain}/user/password/reset-link?email=${encodedEmail}&firstLogin=${firstLogin}`, {
            method: 'POST',
        }).catch((err) => {
            throw err;
        });
    }

    verifyTokenAndSendNewPassword(token, body) {
        const encodedValue = encodeURIComponent(token);
        return this.fetch(`${this.domain}/user/password/verify-reset-link?token=${encodedValue}`, {
            method: 'POST',
            body: JSON.stringify(body),
        }).catch((err) => {
            throw err;
        });
    }

    changeRoleType(sapRoleId) {
        return this.fetch(`${this.domain}/user/change-role-type?sapRoleId=${sapRoleId}`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }

    changeLanguage(language) {
        return this.fetch(`${this.domain}/user/change-language?language=${language}`, {
            method: 'PUT',
        }).catch((err) => {
            throw err;
        });
    }
}
